import React from "react";

export default function AdSection() {
  return (
    <>
      {/* <div className="w-full flex items-center justify-center py-4">
      <div className="bg-[#EDEDED] w-full md:w-[90%] h-20 md:h-40 flex items-center justify-center">
        <p className="text-gray-700 font-semibold text-xl">AD</p>
      </div>
    </div> */}
    </>
  );
}
